import { logger } from "../../../utils/logger.es.js";
import { getSessionId } from "./getSession.es.js";
import { getUserInsights } from "./getUserInsights.es.js";
import { setSharedServicesUrl } from "../../../utils/sharedServiceUrl.es.js";
import "../../services/idcs-service.es.js";
import "../../../cookies-04bd2321.js";
import "../utils/getUtmParams.es.js";
import "./utils.es.js";
import "../../../utils/deepEquals.es.js";
import "../../../utils/merkleDataTracker.es.js";
import "../../../utils/userInsights.es.js";
import "../../../getTealiumIds-c24d3498.js";
import "../../../waitFor-1b67bbb8.js";
import "../merkle/getMerkleIds.es.js";
import "../visitId/visitId.es.js";
import "../../../cookieHandler-ac6954c1.js";
import "../visitId/adapter.es.js";
import "../../../processUrlVisitId-15beb53d.js";
import "../../../v4-88c20f3b.js";
import "../visitId/utils.es.js";
import "../visitId/constants.es.js";
const analyticsSessionId = ({ url } = {}) => {
  let sessionPromise = null;
  if (url)
    setSharedServicesUrl(url);
  const getOrCreateSession = (search) => {
    if (!sessionPromise) {
      sessionPromise = getSessionId(search);
    }
    return sessionPromise;
  };
  return {
    name: "analytics-idcs-session",
    page: async ({ payload }) => {
      var _a;
      try {
        const sessionId = await getOrCreateSession((_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.search);
        await getUserInsights();
        if (sessionId) {
          const ids = payload.properties.ids || {};
          const allIds = { ...ids, session_id: sessionId };
          payload.properties = {
            ...payload.properties,
            ids: allIds
          };
        }
      } catch (error) {
        logger.error("Failed to process session id:", error);
      }
    },
    track: async ({ payload }) => {
      var _a;
      try {
        const sessionId = await getOrCreateSession((_a = payload == null ? void 0 : payload.properties) == null ? void 0 : _a.search);
        await getUserInsights();
        if (sessionId) {
          const ids = payload.properties.ids || {};
          const allIds = { ...ids, session_id: sessionId };
          payload.properties = {
            ...payload.properties,
            ids: allIds
          };
        }
      } catch (error) {
        logger.error("Failed to process session id:", error);
      }
    }
  };
};
export {
  analyticsSessionId
};
